import { AxiosResponse } from "axios";
import { Base } from "@tt-app/api/base";
import { Assignment as AssignmentType, AssignmentDetails } from "@tt-app/types";
import { API_ENDPOINTS } from "@tt-app/constants/api";

const {
  ASSIGNMENT: { ACTIVE_LIST, DETAILS, LIST, MINE }
} = API_ENDPOINTS;

class Assignment extends Base {
  async activeList(payload: any): Promise<AxiosResponse<AssignmentType[]>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(ACTIVE_LIST, { headers });
  }
  async mine(payload: any) {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(MINE, { headers });
  }
  async details(payload: any): Promise<AxiosResponse<AssignmentDetails>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(`${DETAILS}/${payload.assignmentId}/`, { headers });
  }
  async list(payload: any): Promise<AxiosResponse<AssignmentType[]>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };
    return this.httpClient.get(LIST, { headers });
  }
}

export { Assignment };
